import { render, staticRenderFns } from "./exclamation.vue?vue&type=template&id=c9ee995a&"
import script from "./exclamation.vue?vue&type=script&lang=js&"
export * from "./exclamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports